module.exports = __webpack_public_path__ + "img/promo-header-image.f94f5992.png";